/* import __COLOCATED_TEMPLATE__ from './seller-posting-deliverables-input.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { createCache, getValue } from '@glimmer/tracking/primitives/cache';
import clsx from 'clsx';

const CLASS_NAME = 'seller-posting-deliverables';

const MAX_DESCRIPTION_LENGTH = 80;

export const createDeliverable = (description = '') => ({
  guid: crypto.randomUUID(),
  description,
});

class SellerPostingDeliverablesInputComponent extends Component {
  get classNames() {
    return clsx(
      this.args.class,
      CLASS_NAME,
    );
  }

  get className() {
    return CLASS_NAME;
  }

  get placeholder() {
    return this.lastDeliverablesIndex < 1 ?
      this.args.initialPlaceholder
      : this.args.placeholder;
  }

  get maxDescriptionLength() {
    return MAX_DESCRIPTION_LENGTH;
  }

  #deliverables = createCache(() => {
    const deliverables = [...this.args.deliverables];

    // provide blank fields if there are zero or they began filling the previous field
    const lastDeliverable = deliverables[deliverables.length - 1];
    if (deliverables.length === 0 || lastDeliverable?.description) {
      deliverables.push(createDeliverable());
    }

    return deliverables;
  });

  get deliverables() {
    return getValue(this.#deliverables);
  }

  get lastDeliverablesIndex() {
    return this.deliverables.length - 1;
  }

  /**
   *
   */
  @action
  handleDeleteDeliverable(index) {
    // remove index
    const deliverables = [...this.deliverables];
    deliverables.splice(index, 1);

    // update with changes
    this.args.onupdate?.(deliverables);
  }

  /**
   *
   */
  @action
  handleInput(index, value) {
    const deliverables = [...this.deliverables];
    deliverables[index] = { ...deliverables[index], description: value };

    // update with changes
    this.args.onupdate?.(deliverables);
  }
}

export default SellerPostingDeliverablesInputComponent;
